import { Component, OnInit, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter }  from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { Offer } from '@app/modules/model/offer';
import { Discount } from '@app/modules/model/discount';

import { languageSupport, languageService } from '@app/modules/common/language'
import { viewService } from '@app/modules/view';

import { GenericUtils } from '@app/app.commonutils';

@Component({
    selector: 'ui-offer-thumbnail',
    templateUrl:'./ui-thumb.html',
    styleUrls: [ 
        './ui-thumb.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiOfferThumbnail extends languageSupport implements OnInit, OnDestroy {
    @Input('offer') _item: Offer | Discount = null;

    private _subscriptions = [];

    normalize(str){
        return GenericUtils.Normalize(str);
    }

    get IsOffer(){
        return this._item && (this._item instanceof Offer) && ((this._item as Offer).ismenu == false);
    }

    get IsMenu(){
        return this._item && (this._item instanceof Offer) && ((this._item as Offer).ismenu == true);
    }

    get IsDiscount(){
        return this._item && (this._item instanceof Discount);
    }

    /***********************************/
    /* STARTS HERE                     */
    /***********************************/

    constructor(private lang: languageService, private change: ChangeDetectorRef, public view: viewService) {
        super(lang, change);
    }

    ngOnInit(){
        if (this._item){
            // refresh on offer changes
            this._subscriptions.push(
                this._item.OnRefresh.subscribe(
                data => {
                    this.change.markForCheck();
                })
            );    

            // refresh on theme changed
            this._subscriptions.push(
                this.view.OnTheme.subscribe(
                data => {
                    this.change.markForCheck();
                })
            );            
        }
    }

    ngOnDestroy(){
        super.OnDestroy();

        for(let _subscription of this._subscriptions){
            _subscription.unsubscribe();
        }
        this._subscriptions = [];
    }

    /***********************************/
    /* EVENT HANDLERS                  */
    /***********************************/

    @Output('onSelect') _onSelect = new EventEmitter<any>();         
    OnSelect(){
        this._onSelect.emit(this._item);
    }
}
